<template>
  <div class="update-user">
    <p class="update-user__title h3">
      Редактирования пользователя
    </p>

    <div class="update-user-avatar">
      <AvatarBorder
        :image="avatar"
        class="update-user-avatar__image"
      />

      <BtnIcon
        icon="pencil"
        class="update-user-avatar__btn"
        @click="$refs.fileInput.click()"
      />

      <input
        accept="image/jpeg,image/png"
        type="file"
        ref="fileInput"
        hidden
        @change="onFile"
      >
    </div>

    <InputWrapper title="Логин">
      <BaseInput v-model="form.username" />
      <InvalidFeedback v-if="v$.form.$dirty && v$.form.username.required.$invalid">
        {{ errorText.required }}
      </InvalidFeedback>
      <InvalidFeedback v-if="v$.form.$dirty && v$.form.username.minLength.$invalid">
        {{ errorText.minLength(v$.form.username.minLength.$params.min) }}
      </InvalidFeedback>
    </InputWrapper>

    <InputWrapper title="Пароль">
      <BaseInput v-model="form.password" />
      <InvalidFeedback v-if="v$.form.$dirty && v$.form.password.minLength.$invalid">
        {{ errorText.minLength(v$.form.password.minLength.$params.min) }}
      </InvalidFeedback>
    </InputWrapper>

    <InputWrapper title="Выберите роль">
      <BaseSelect
        v-model="form.role"
        :options="options.roles"
      />
<!--      <InvalidFeedback v-if="v$.form.$dirty && v$.form.role.required.$invalid">-->
<!--        {{ errorText.required }}-->
<!--      </InvalidFeedback>-->
    </InputWrapper>

    <InputWrapper title="Введите имя">
      <BaseInput v-model="form.name" />
      <InvalidFeedback v-if="v$.form.$dirty && v$.form.name.required.$invalid">
        {{ errorText.required }}
      </InvalidFeedback>
    </InputWrapper>

    <InputWrapper title="Введите фамилию">
      <BaseInput v-model="form.surname" />
      <InvalidFeedback v-if="v$.form.$dirty && v$.form.surname.required.$invalid">
        {{ errorText.required }}
      </InvalidFeedback>
    </InputWrapper>

    <RadioWrapper
      title="Пол"
      class="update-user__radio-wrapper"
    >
      <BaseRadio
        v-model="form.gender"
        :value="1"
        label="Женский"
      />
      <BaseRadio
        v-model="form.gender"
        :value="0"
        label="Мужской"
      />
    </RadioWrapper>

    <InputWrapper title="Введите почту">
      <BaseInput v-model="form.email" />
      <InvalidFeedback v-if="v$.form.$dirty && v$.form.email.required.$invalid">
        {{ errorText.required }}
      </InvalidFeedback>
      <InvalidFeedback v-if="v$.form.$dirty && v$.form.email.email.$invalid">
        {{ errorText.email }}
      </InvalidFeedback>
    </InputWrapper>

    <InputWrapper title="Введите номер телефона">
      <BaseInput v-model="form.phone" />
      <InvalidFeedback v-if="v$.form.$dirty && v$.form.phone.required.$invalid">
        {{ errorText.required }}
      </InvalidFeedback>
      <InvalidFeedback v-if="v$.form.$dirty && v$.form.phone.numeric.$invalid">
        {{ errorText.numeric }}
      </InvalidFeedback>
      <InvalidFeedback v-if="v$.form.$dirty && v$.form.phone.length.$invalid">
        Номер должен начинаться с "9" и содержать 10 символов.
      </InvalidFeedback>
    </InputWrapper>

    <InputWrapper title="Введите дату рождения">
      <BaseInput v-model="form.birthday" type="date" />
      <InvalidFeedback v-if="v$.form.$dirty && v$.form.birthday.required.$invalid">
        {{ errorText.required }}
      </InvalidFeedback>
    </InputWrapper>

    <InputWrapper title="Выберите позицию">
      <BaseSelect
        v-model="form.position"
        :options="options.positions"
      />
      <InvalidFeedback v-if="v$.form.$dirty && v$.form.position.required.$invalid">
        {{ errorText.required }}
      </InvalidFeedback>
    </InputWrapper>

    <InputWrapper title="Введите свой вес">
      <BaseInput v-model="form.weight" />
      <InvalidFeedback v-if="v$.form.$dirty && v$.form.weight.numeric.$invalid">
        {{ errorText.numeric }}
      </InvalidFeedback>
    </InputWrapper>

    <InputWrapper title="Введите свой рост">
      <BaseInput v-model="form.height" />
      <InvalidFeedback v-if="v$.form.$dirty && v$.form.height.numeric.$invalid">
        {{ errorText.numeric }}
      </InvalidFeedback>
    </InputWrapper>

    <div class="panel">
      <BaseButton
        class="panel__btn"
        @click="onSave"
      >
        Сохранить
      </BaseButton>
      <BaseButton
        class="panel__btn"
        theme="light"
        :href="'/user/' + $route.params.id"
      >
        Отмена
      </BaseButton>
    </div>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required, minLength, email, numeric } from '@vuelidate/validators'

import BaseInput from '@/components/Base/BaseInput'
import InputWrapper from '@/components/InputWrapper'
import InvalidFeedback from '@/components/InvalidFeedback'
import BaseButton from '@/components/Base/BaseButton'
import RadioWrapper from '@/components/RadioWrapper'
import BaseRadio from '@/components/Base/BaseRadio'
import BaseSelect from '@/components/Base/BaseSelect'
import AvatarBorder from '@/components/AvatarBorder'
import BtnIcon from '@/components/Base/BtnIcon'

export default {
  name: 'PageUpdateUser',
  components: {
    BtnIcon,
    AvatarBorder,
    BaseButton,
    BaseInput,
    InputWrapper,
    InvalidFeedback,
    RadioWrapper,
    BaseRadio,
    BaseSelect
  },
  setup () {
    return { v$: useVuelidate() }
  },
  data () {
    return {
      avatar: '',
      form: {
        username: '',
        password: '',
        role: '',
        name: '',
        surname: '',
        gender: 0,
        email: '',
        phone: '',
        birthday: '',
        position: '',
        weight: '',
        height: ''
      },
      options: {
        positions: [],
        roles: []
      }
    }
  },
  computed: {
    errorText () {
      return this.$store.state.errors.inputErrors
    }
  },
  async created () {
    await this.init()
    await this.fetchOptions()
  },
  methods: {
    async onSave () {
      if (this.v$.form.$invalid) {
        this.v$.form.$touch()
        return
      }

      const birthday = this.form.birthday ?? ''
      const body = {
        username: this.form.username,
        role: this.form.role,
        surname: this.form.surname,
        name: this.form.name,
        gender: this.form.gender,
        email: this.form.email,
        phone: this.form.phone,
        birthday: birthday.split('-').reverse().join('-'),
        position: this.form.position
      }

      if (this.form.height) { body.height = this.form.height }
      if (this.form.weight) { body.weight = this.form.weight }
      if (this.form.password) { body.password = this.form.password }

      try {
        await this.$api.user.edit(this.$route.params.id, body)
        this.$router.push('/user/' + this.$route.params.id)
      } catch (e) {
        console.log(e)
        alert('Произошла ошибка.')
      }
    },
    async fetchOptions () {
      try {
        const res = await this.$api.user.positions(this.$route.params.id)
        this.options.positions = res?.data?.position ?? []
        this.options.roles = res?.data?.role ?? []
      } catch (e) {
        console.log(e)
      }
    },
    async init () {
      const res = await this.$api.user.user(this.$route.params.id)
      const data = res?.data

      let birthday = data.birthday ?? ''
      birthday = birthday.split('.').reverse().join('-')

      this.avatar = data?.photo?.url
      this.form.username = data?.username
      this.form.role = data.role?.value
      this.form.name = data.name
      this.form.surname = data.surname
      this.form.gender = data.gender?.value ?? 0
      this.form.email = data.email
      this.form.phone = data.phone
      this.form.birthday = birthday
      this.form.position = data.positionId
      this.form.weight = data.weight
      this.form.height = data.height
    },
    async onFile (event) {
      const photo = event.target.files[0]
      function getBase64 (file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = () => resolve(reader.result)
          reader.onerror = error => reject(error)
        })
      }

      try {
        const base64File = await getBase64(photo)
        await this.$api.user.uploadAvatar({
          userId: this.$route.params.id,
          base64File
        })
        this.avatar = base64File
      } catch (e) {
        console.log(e)
      }
    }
  },
  validations: {
    form: {
      username: {
        required,
        minLength: minLength(8)
      },
      password: {
        minLength: minLength(8)
      },
      name: {
        required
      },
      surname: {
        required
      },
      email: {
        required,
        email
      },
      phone: {
        required,
        numeric,
        length: (val) => {
          return (String(val).length === 10) && (String(val)[0] === '9')
        }
      },
      birthday: {
        required
      },
      position: {
        required
      },
      weight: {
        numeric
      },
      height: {
        numeric
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.update-user {
  max-width: 600px;

  &-avatar {
    display: inline-block;
    position: relative;

    &__image {
      margin-top: 36px;
      width: 120px;
      border-radius: 1000px;
      font-size: 50px;
      font-weight: 600;
    }

    &__btn {
      position: absolute;
      bottom: 0;
      right: 0;
    }
  }

  &__radio-wrapper {
    width: 180px;
    margin-top: 20px;
    display: inline-block;
  }

  .panel {
    margin-top: 50px;

    &__btn:not(:last-child) {
      margin-right: 20px;
    }
  }
}
</style>
